module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doNotDesactiveOnClick dynamicAnswers",
    class: {
      maybe: _vm.mayBeAllowed, open: _vm.open, noAnimation: _vm.noAnimation
    },
    attrs: {
      "id": "dynamicAnswers"
    },
    on: {
      "mouseleave": _vm.hide
    }
  }, [(_vm.isUser) ? _c('div', {
    staticClass: "user"
  }, [_c('i', {
    staticClass: "fa fa-user green",
    class: {
      selected: _vm.isYes, notSelected: !_vm.isYes
    },
    attrs: {
      "title": _vm.$t("events.answers.user.present")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer("Yes")
      }
    }
  }), _c('i', {
    staticClass: "fa fa-user red",
    class: {
      selected: _vm.isNo, notSelected: !_vm.isNo
    },
    attrs: {
      "title": _vm.$t("events.answers.user.absent")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer("No")
      }
    }
  }), (_vm.mayBeAllowed) ? _c('i', {
    staticClass: "fa fa-user orange",
    class: {
      selected: _vm.isMaybe, notSelected: !_vm.isMaybe
    },
    attrs: {
      "title": _vm.$t("events.answers.user.maybe")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer("Maybe")
      }
    }
  }) : _vm._e(), _c('i', {
    staticClass: "fa fa-user",
    class: {
      selected: _vm.noAnswer, notSelected: !_vm.noAnswer
    },
    attrs: {
      "title": _vm.$t("events.answers.user.noanswer")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer(null)
      }
    }
  })]) : _vm._e(), (_vm.isGroup) ? _c('div', {
    staticClass: "group"
  }, [_c('i', {
    staticClass: "fa fa-group green",
    class: {
      selected: _vm.isYes, notSelected: !_vm.isYes
    },
    attrs: {
      "title": _vm.$t("events.answers.group.accepted")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer("Yes")
      }
    }
  }), _c('i', {
    staticClass: "fa fa-group red",
    class: {
      selected: _vm.isNo, notSelected: !_vm.isNo
    },
    attrs: {
      "title": _vm.$t("events.answers.group.refused")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer("No")
      }
    }
  }), _c('i', {
    staticClass: "fa fa-group",
    class: {
      selected: _vm.noAnswer, notSelected: !_vm.noAnswer
    },
    attrs: {
      "title": _vm.$t("events.answers.group.noanswer")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer(null)
      }
    }
  })]) : _vm._e(), (_vm.isStatus) ? _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-check green",
    class: {
      selected: _vm.isYes, notSelected: !_vm.isYes
    },
    attrs: {
      "title": _vm.$t("events.answers.event.confirmed")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer("CONFIRMED")
      }
    }
  }), _c('i', {
    staticClass: "fa fa-times red",
    class: {
      selected: _vm.isNo, notSelected: !_vm.isNo
    },
    attrs: {
      "title": _vm.$t("events.answers.event.refused")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer("REFUSED")
      }
    }
  }), _c('i', {
    staticClass: "fa fa-question",
    class: {
      selected: _vm.noAnswer, notSelected: !_vm.noAnswer
    },
    attrs: {
      "title": _vm.$t("events.answers.event.waiting")
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer("WAITING")
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bbef396","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AnsweringHover.vue
// module id = 1261
// module chunks = 1